import {
  ChefHat,
  ClipboardList,
  MonitorSmartphone,
  Package,
  Palette,
  Printer,
  Settings2,
} from 'lucide-react';
import { RestaurantSettingsSectionKey } from './RestaurantSettingsTypes';

interface Props {
  activeSection: RestaurantSettingsSectionKey;
  onChange: (section: RestaurantSettingsSectionKey) => void;
}

const items = [
  { key: 'general', label: 'General', icon: Settings2 },
  { key: 'pos', label: 'POS', icon: MonitorSmartphone },
  { key: 'kitchen', label: 'Cocina', icon: ChefHat },
  { key: 'inventory', label: 'Inventario', icon: Package },
  { key: 'reservations', label: 'Reservaciones', icon: ClipboardList },
  { key: 'printing', label: 'Impresión', icon: Printer },
  { key: 'appearance', label: 'Apariencia', icon: Palette },
] as const;

const RestaurantSettingsSidebar = ({ activeSection, onChange }: Props) => (
  <aside
    className="border-b border-stroke bg-gray-2 p-3 dark:border-strokedark dark:bg-meta-4/20 md:w-64 md:flex-none md:border-b-0 md:border-r"
    aria-label="Secciones de configuración"
  >
    <p className="mb-3 px-3 text-xs font-semibold uppercase tracking-wider text-bodydark2">
      Configuración
    </p>

    <nav className="grid grid-cols-2 gap-2 sm:grid-cols-3 md:grid-cols-1">
      {items.map(({ key, label, icon: Icon }) => {
        const active = activeSection === key;

        return (
          <button
            key={key}
            type="button"
            onClick={() => onChange(key)}
            aria-current={active ? 'page' : undefined}
            className={`
              flex
              items-center
              gap-3

              rounded-xl

              border
              border-transparent

              px-3
              py-3

              text-left
              text-sm
              font-medium

              transition-all
              duration-200

              ${
                active
                  ? `
                    border-primary
                    bg-primary
                    text-white

                    shadow-sm
                  `
                  : `
                    text-black

                    hover:border-stroke
                    hover:bg-gray
                    hover:text-primary

                    dark:text-white
                    dark:hover:border-strokedark
                    dark:hover:bg-meta-4
                    dark:hover:text-primary
                  `
              }
            `}
          >
            <Icon className="h-4.5 w-4.5 flex-none" />

            <span className="truncate">{label}</span>
          </button>
        );
      })}
    </nav>
  </aside>
);

export default RestaurantSettingsSidebar;
